export default __webpack_public_path__ + "static/media/x2y2.6b51a2bf.png";